var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "InstagramLogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.293 12.0225C14.0838 12.0225 12.293 13.8133 12.293 16.0225C12.293 18.2316 14.0838 20.0225 16.293 20.0225C18.5021 20.0225 20.293 18.2316 20.293 16.0225C20.293 13.8133 18.5021 12.0225 16.293 12.0225ZM10.293 16.0225C10.293 12.7088 12.9793 10.0225 16.293 10.0225C19.6067 10.0225 22.293 12.7088 22.293 16.0225C22.293 19.3362 19.6067 22.0225 16.293 22.0225C12.9793 22.0225 10.293 19.3362 10.293 16.0225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.793 5.52246C8.03154 5.52246 5.79297 7.76104 5.79297 10.5225V21.5225C5.79297 24.2839 8.03154 26.5225 10.793 26.5225H21.793C24.5544 26.5225 26.793 24.2839 26.793 21.5225V10.5225C26.793 7.76104 24.5544 5.52246 21.793 5.52246H10.793ZM3.79297 10.5225C3.79297 6.65647 6.92698 3.52246 10.793 3.52246H21.793C25.659 3.52246 28.793 6.65647 28.793 10.5225V21.5225C28.793 25.3885 25.659 28.5225 21.793 28.5225H10.793C6.92698 28.5225 3.79297 25.3885 3.79297 21.5225V10.5225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.793 11.0225C23.6214 11.0225 24.293 10.3509 24.293 9.52246C24.293 8.69403 23.6214 8.02246 22.793 8.02246C21.9645 8.02246 21.293 8.69403 21.293 9.52246C21.293 10.3509 21.9645 11.0225 22.793 11.0225Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/InstagramLogo.c8212141f06f057a3bf024d66c949fec.svg";
export { ForwardRef as ReactComponent };